import { render } from "./admin-analytics.svg?vue&type=template&id=be458f98"
const script = {}
script.render = render

export default script